import Image from "next/image";
import { User } from "../../../models";
import Img from "../images/Img";

export interface AvatarProps {
  user: User;
  width: number;
  height: number;
  src?: string;
}

const Avatar: React.FC<AvatarProps> = ({ user, width, height, src }) => {
  const { profilePicture } = user;
  if (!profilePicture)
    return (
      <div
        className="flex items-center justify-center text-white uppercase bg-black rounded-full dark:bg-theme-dark-light"
        style={{ width, height, fontSize: width / 2 }}
      >
        {user?.username?.[0]}
      </div>
    );
  return (
    <Img
      image={profilePicture}
      src={src}
      cloudinaryTransformation={{
        resize: { type: "fill", width: 240, height: 240 },
      }}
      className="object-cover rounded-full"
      width={width}
      height={height}
    />
  );
};

export default Avatar;
